import React from "react";
import { MapStateToPropsParam } from "react-redux";

import { counsellingsHomeUrl } from "@/mk2/apps/counsellings/urls";
import { forumReadFeedTrigger } from "@/mk2/apps/forum/actions";
import TopicPage, {
    DispatchProps,
    OwnProps,
    Props,
    RouteProps,
    StateProps,
    TopicViewType,
} from "@/mk2/apps/forum/containers/Topic/TopicPage";
import {
    breadcrumbsCounsellings,
    counsellingCollectionPage,
} from "@/mk2/apps/forum/structuredData";
import { AppName } from "@/mk2/containers/Application/Application";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { RightContentSide } from "@/mk2/pages/Page";
import { AppState } from "@/mk2/reducers";
import { MenuSelection } from "@/mk2/schemas";
import { SEO_TITLE_COUNSELLINGS } from "@/mk/autogenerated/translations/CounsellingsTopicPage.1778130b53c20e5d09618f67ad32b65d";

export default class CounsellingsTopicPage extends TopicPage {
    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {
                ...(super.mapStateToProps()(state, ownProps) as StateProps),
                viewType: TopicViewType.AskAnExpert,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...super.mapDispatchToProps(),
            onRead: (topicId: number) => forumReadFeedTrigger(`subscribedCounsellings_${topicId}`),
        };
    }

    public getMetaTitle(props: Props): string {
        const { topic } = props;
        return topic ? topic.name : SEO_TITLE_COUNSELLINGS;
    }

    public getStructuredData(props: Props): object[] {
        const { topic, baseUrl, counselling } = props;

        if (topic) {
            const collectionPage =
                counselling && counsellingCollectionPage(baseUrl, topic, counselling);
            return [
                breadcrumbsCounsellings(baseUrl, topic),
                ...(collectionPage ? [collectionPage] : []),
            ];
        }
    }

    public renderRight(props: Props): JSX.Element {
        return null;
    }

    public getRightContentSide(app: AppName, props: Props): RightContentSide {
        return RightContentSide.RightSide;
    }

    public getDefaultBackPath(props: Props): string {
        return counsellingsHomeUrl;
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: "counsellings",
            activeItem: undefined,
        };
    }
}
